// extracted by mini-css-extract-plugin
module.exports = {"contained":"Errors_contained__3JOgJ","global":"Errors_global__2YyEd","error":"Errors_error__2Ite-","globalError":"Errors_globalError__1NAPY"};